import React from "react";
import { ThemeProvider } from "@rneui/themed";
import { useThemeSelection } from "./theme";

export const ThemeWrapper = ({ children }: { children: React.ReactElement }) => {
	const theme = useThemeSelection();

	return (
		<ThemeProvider theme={theme}>
			{children}
		</ThemeProvider>
	);
};
